import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

	
@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { }

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;

  /* On with the show */
ngOnInit() {

		this.title = 'Privacy';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
		this.subtitle = 'Privacy Policy';
  		this.headerHeight = '400px';
  }

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/terms/privacy.component.ts